import React, { Component } from 'react';
import PageTitle from '../home/PageTitle';
import ApiURL from '../../api/ApiURL';
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';
import axios from 'axios';
import cogoToast from 'cogo-toast';
import { ExportToExcel } from '../common/ExcelFile';
import BookingReportModal from './BookingReportModal';
import TravelReportModal from './TravelReportModal';
import VendorPayableReportModal from './VendorPayableReportModal';
import DayRegisterReportModal from './DayRegisterReportModal';

class ReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tcData: [],
            bookingData: [],
            userId: 0,
            userRole: "",
            showBkRptModal: false,
            showTravelRptModal: false,
            showVendorPayableRptModal: false,
            showDayRegRptModal: false,
            redirectToLogin: false
        };
    }
    //ComponentDidMount
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                userId: userData.UserId,
                userRole: userData.RoleName
            })
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ redirectToLogin: true })
        }
        this.getAllTCData();
    }
    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ ...this.state, tcData: dataResult });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Close modal
    closeModal = () => {
        this.setState({
            showBkRptModal: false,
            showTravelRptModal: false,
            showVendorPayableRptModal: false,
            showDayRegRptModal: false
        })
    }
    //Open download excel modal
    onDownloadExcel = (rptId) => {
        switch (rptId) {
            case 1:
                //alert(rptId);
                this.setState({ showBkRptModal: true })
                break;
            case 2:
                //alert(rptId);
                this.setState({ showTravelRptModal: true })
                break;
            case 3:
                //alert(rptId);                
                this.setState({ showDayRegRptModal: true })
                //cogoToast.info("The report is not available at the moment. Please contact the administrator.", { position: "bottom-center" });
                break;
            case 4:
                //alert(rptId);
                this.setState({ showVendorPayableRptModal: true })
                break;
        }
    }

    render() {
        var { tcData, showBkRptModal, showTravelRptModal, showVendorPayableRptModal, showDayRegRptModal } = this.state;
        return (
            <>
                <div className="master-page">
                    <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                        <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                            <div className="col-md-6 justify-content-start">
                                <PageTitle Title="Manage Report Data" />
                            </div>
                        </div>
                    </div>
                    <div className="master-page__body">
                        <div className="card border border-primary shadow-sm report-list-card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3 col-sm-6 mb-3 mb-md-0">
                                        <ExportToExcel id={1} rptName={"Booking Report"} onDownloadExcel={this.onDownloadExcel} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 mb-3 mb-md-0">
                                        <ExportToExcel id={2} rptName={"Travel Report"} onDownloadExcel={this.onDownloadExcel} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 mb-3 mb-md-0">
                                        <ExportToExcel id={3} rptName={"Day Register Report"} onDownloadExcel={this.onDownloadExcel} />
                                    </div>
                                    <div className="col-md-3 col-sm-6">
                                        <ExportToExcel id={4} rptName={"Vendor Due Payable Report"} onDownloadExcel={this.onDownloadExcel} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!-- Booking Report modal section --> */}
                <BookingReportModal
                    show={showBkRptModal}
                    tcData={tcData}
                    onClose={this.closeModal}
                />
                {/* <!----------> */}

                {/* <!-- Travel Report modal section --> */}
                <TravelReportModal
                    show={showTravelRptModal}
                    tcData={tcData}
                    onClose={this.closeModal}
                />
                {/* <!----------> */}

                {/* <!-- Vendor Payable Report modal section --> */}
                <VendorPayableReportModal
                    show={showVendorPayableRptModal}
                    tcData={tcData}
                    onClose={this.closeModal}
                />
                {/* <!----------> */}

                {/* <!-- Booking Report modal section --> */}
                <DayRegisterReportModal
                    show={showDayRegRptModal}
                    tcData={tcData}
                    onClose={this.closeModal}
                />
                {/* <!----------> */}
            </>
        );
    }
}

export default ReportList;